<div class="ui-grid-cell-contents w-100 h-100">
  @for (tag of tags(); track tag.id) {
    <em
      class="fas fa-tag"
      [matTooltip]="tag.name"
      [style.color]="tag.color"
    ></em>
  }
</div>
